import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-toolbar" }
const _hoisted_2 = { class: "me-n3" }
const _hoisted_3 = {
  key: 0,
  class: "form-check form-check-custom form-check-solid d-block d-md-inline-block me-5 mb-3"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, "Set as template", -1)
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Create ", -1)
const _hoisted_8 = { class: "indicator-progress" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_10 = {
  key: 2,
  class: "dropdown d-inline-block"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-outline btn-outline-primary btn-active-light-primary me-5 dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton1",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " Preview ", -1)
const _hoisted_12 = {
  class: "dropdown-menu border-1",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-tablet fs-4 me-2 text-dark" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Tablet")
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-phone fs-4 me-2 text-dark" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Mobile")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Publish ", -1)
const _hoisted_22 = { class: "indicator-progress" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DiscardConfirmationModal = _resolveComponent("DiscardConfirmationModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.designCreated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "flexCheckDefault",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isTemp) = $event)),
              disabled: _ctx.disabled || _ctx.loading,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-is-template', _ctx.isTemp)))
            }, null, 8, _hoisted_4), [
              [_vModelCheckbox, _ctx.isTemp]
            ]),
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      (!_ctx.designCreated)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-outline btn-outline-primary btn-active-light-primary me-5",
            onClick: _cache[2] || (_cache[2] = 
          () => {
            _ctx.showDetailDialog = true;
            _ctx.$emit('create-table');
          }
        ),
            disabled: _ctx.loading,
            ref: "createTableBtn"
          }, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
              _hoisted_9
            ])
          ], 8, _hoisted_6))
        : _createCommentVNode("", true),
      (_ctx.designCreated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("ul", _hoisted_12, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item py-3 border-bottom text-hover-primary",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#tabletModal",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('get-preview-data', 'tablet')))
                }, _hoisted_15)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item py-3 text-hover-primary",
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#smartphoneModal",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('get-preview-data', 'mobile')))
                }, _hoisted_18)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.designCreated)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            class: "btn btn-outline btn-outline-primary btn-active-light-primary me-5",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDetailDialog = true)),
            disabled: _ctx.disabled || _ctx.loading
          }, " Discard ", 8, _hoisted_19))
        : _createCommentVNode("", true),
      (_ctx.designCreated)
        ? (_openBlock(), _createElementBlock("button", {
            key: 4,
            class: "btn btn-outline btn-outline-primary btn-active-light-primary me-5",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('save-data', _ctx.isTemp))),
            disabled: _ctx.disabled || _ctx.loading,
            ref: "publishButton"
          }, [
            _hoisted_21,
            _createElementVNode("span", _hoisted_22, [
              _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
              _hoisted_23
            ])
          ], 8, _hoisted_20))
        : _createCommentVNode("", true)
    ]),
    (_ctx.designCreated)
      ? (_openBlock(), _createBlock(_component_DiscardConfirmationModal, {
          key: 0,
          onConfirmDiscard: _cache[7] || (_cache[7] = 
        () => {
          _ctx.showDetailDialog = false;
          _ctx.$emit('confirm-discard');
        }
      ),
          showDialog: _ctx.showDetailDialog,
          onCloseDetail: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showDetailDialog = false))
        }, null, 8, ["showDialog"]))
      : _createCommentVNode("", true)
  ]))
}